// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","sectionTitle":"_3znab63ix4t3i47_aioW_z","link":"_3netMC7_LK-TgUNBHEHRw6","chevron":"_2n-LbgQS-qIq7Z0JcXYR9V","activeLink":"_3hsnC1qqb9cPpH9_a4f9pr"};